<template>
  <div class="article">
    <div class="article__elements">
      <Cross class="mobile-hidden" img-width="8rem" top="15.5rem" left="26.2rem" color="orange" />
      <Cross class="mobile-hidden" img-width="4.2rem" top="35.8rem" left="22.9rem" color="orange" />
      <Snowflake2 class="mobile-hidden" img-width="7.4rem" bottom="7.4rem" left="9.8rem" color="orange" />
      <Snowflake2 class="mobile-hidden" img-width="4rem" top="21rem" left="67.5rem" color="orange" />
      <Snowflake2 class="mobile-hidden" img-width="8rem" top="24.5rem" right="11.6rem" color="orange" />
      <Snowflake3 class="mobile-hidden" img-width="5.5rem" bottom="25rem" right="8.8rem" color="orange" />
      <Gift3 class="mobile-hidden" img-width="7.5rem" top="24.2rem" left="8rem" />
      <Gift4 class="mobile-hidden" img-width="11.3rem" bottom="9.4rem" right="16rem" />
      <Tree2 class="mobile-hidden" img-width="8rem" bottom="15.2rem" left="60rem" />
      <Plate class="mobile-hidden" img-width="34rem" bottom="0" left="25rem" />
    </div>

    <div class="article__img">
      <img class="mobile-hidden" src="@/assets/img/article3.png" alt="">
      <img class="mobile-visible" src="@/assets/img/article3-mob.png" alt="">
    </div>
    <div class="article__content">
      <h2 class="article__title">
        {{ 'Как добровольческое движение' | typograf }}
      </h2>
      <h2 class="article__title">
        {{ 'спасает жизни' | typograf }}
      </h2>
      <p class="article__subtitle">
        {{ 'Несколько лет назад студент Дмитровского техникума Андрей Барт присоединился к рядам Всероссийского студенческого корпуса спасателей.' | typograf }}
      </p>
      <p class="article__text">
        {{ 'Сейчас молодой человек уже аттестован на спасателя и даже делится опытом с новым поколением. О помощи другим и об участии в новогодней акции #МЫВМЕСТЕ Андрей рассказал «Ленте.ру».' | typograf }}
      </p>
      <div class="article__button-box">
        <a href="https://lenta.ru/articles/2021/12/17/volonterbart/" target="_blank">
          <button @click="gtmSend" class="button button--orange">Читать специальный материал</button>
        </a>
      </div>

      <ArticleFooter />
    </div>
  </div>
</template>

<script>
  import './article.scss'
  import Cross from "../Elements/Cross";

  import Snowflake2 from "../Elements/Snowflake2";
  import ArticleFooter from "../ArticleFooter/ArticleFooter";
  import Gift3 from "../Elements/Gift3";
  import Tree2 from "../Elements/Tree2";
  import Snowflake3 from "../Elements/Snowflake3";
  import Gift4 from "../Elements/Gift4";
  import Plate from "../Elements/Plate";
  export default {
    name: "Article3",
    components: {Plate, Gift4, Snowflake3, Tree2, Gift3, ArticleFooter, Snowflake2, Cross},
    methods: {
      gtmSend() {
        window.gtag('event', 'click', {
          'event_category': 'ch3_link_lenta_ru',
          'event_label': 'chapter_3'
        });
        window.ym(86974684, 'reachGoal', 'ch3_link_lenta_ru/click/chapter_3');
      }
    }
  }
</script>

<style scoped>

</style>
